import type { FileExtension } from '../../../shared/domain/files/fileExtensions.no-deps'

export async function htmlFilesSelect(
    acceptedExtensions: readonly FileExtension[],
    multiple: boolean
): Promise<File[]> {
    // Mock out file select for tests
    if (window.E2E?.htmlFileSelectFiles != null) {
        return Promise.all(
            window.E2E?.htmlFileSelectFiles.map(async ({ name, content, mimeType }) => {
                const blob = await base64toBlob(content)
                return new File([blob], name, { type: mimeType })
            })
        )
    }

    return new Promise<File[]>((resolve) => {
        // adapted from: https://stackoverflow.com/questions/71435515/how-can-i-detect-that-the-cancel-button-has-been-clicked-on-a-input-type-file
        const element = document.createElement('input')
        element.style.opacity = '0'
        element.type = 'file'
        element.accept = acceptedExtensions.join(', ')
        element.multiple = multiple

        element.onchange = () => {
            document.body.removeChild(element)
            return resolve(fileListToArray(element.files))
        }

        document.body.appendChild(element)

        setTimeout(() => {
            element.click()
            const onFocus = () => {
                window.removeEventListener('focus', onFocus)
                document.body.addEventListener('mousemove', onMouseMove)
            }
            const onMouseMove = () => {
                setTimeout(() => {
                    document.body.removeEventListener('mousemove', onMouseMove)
                    if (!element.files.length) {
                        document.body.removeChild(element)
                        return resolve([])
                    }
                }, 50)
            }
            window.addEventListener('focus', onFocus)
        }, 0)
    })
}

function fileListToArray(fileList: FileList) {
    return Array.from(fileList)
}

function base64toBlob(base64: string, type = 'application/octet-stream') {
    return fetch(`data:${type};base64,${base64}`).then((f) => f.blob())
}

export async function htmlCam(type: 'image' | 'video', multiple: boolean): Promise<File[]> {
    return new Promise<File[]>((resolve) => {
        const element = document.createElement('input')
        element.style.opacity = '0'
        element.type = 'file'
        element.accept = `${type}/*`
        element.capture = `${type === 'image' ? 'camera' : 'camcorder'}`
        element.multiple = multiple

        element.onchange = () => {
            document.body.removeChild(element)
            return resolve(fileListToArray(element.files))
        }

        document.body.appendChild(element)

        setTimeout(() => {
            element.click()
            const onFocus = () => {
                window.removeEventListener('focus', onFocus)
                document.body.addEventListener('mousemove', onMouseMove)
            }
            const onMouseMove = () => {
                document.body.removeEventListener('mousemove', onMouseMove)
                if (!element.files.length) {
                    document.body.removeChild(element)
                    return resolve([])
                }
            }
            window.addEventListener('focus', onFocus)
        }, 0)
    })
}
